import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useOpenEditUserModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createUser')
  const openModal = useOpenEditUserModal()
  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openModal} />
}

export default AddNewButton
